import {ModuleWithProviders, NgModule} from "@angular/core";
import {BdpkConfigService} from "../bdpk-common/services/bdpk-config.service";
import {PitBpmRestService} from "./services/pit-bpm-rest.service";
import {PitFileUploadModalComponent} from "../pit-common/ui/components/file-upload-modal/pit-file-upload-modal.component";
import {DxFormsModule} from "../dx-forms/dx-forms.module";
import {BdpkFileService} from "../bdpk-common/services/bdpk-file.service";
import {PitFilterTreeService} from "./services/filter-tree/pit-filter-tree.service";
import {PitGridModalsService} from "./services/pit-grid-modals.service";
import {PitResponsiblesService} from "./services/pit-responsibles.service";
import {PitUsersService} from "./services/pit-users.service";


/**
 *  Модуль для system-wide (сингтоны для системы в целом) прикладных сервисов.
 *  Здесь лежат только сервисы. Компоненты лежат в {@link PitCommonModule}
 */
@NgModule({
  providers: [
    BdpkConfigService,
    PitBpmRestService,
    BdpkFileService,
    PitGridModalsService,
    PitResponsiblesService,
    PitUsersService,
    PitFilterTreeService
  ],
  bootstrap: []
})
export class PitSharedModule {}
